import { Component, OnInit } from '@angular/core';
import { Interaction } from '../interaction.model';
import { InteractionsService } from '../interactions.service';

@Component({
  selector: 'app-all-interactions',
  templateUrl: './all-interactions.component.html',
  styleUrls: ['./all-interactions.component.scss']
})
export class AllInteractionsComponent implements OnInit {

  interactions: Interaction[] = [];
  lastExp = null;

  constructor( private intService: InteractionsService) { }

  ngOnInit(): void {
    this.intService.getAllInteractions()
    .subscribe((res: {data: Interaction[], message: string}) => {
      this.interactions = res.data;
    });

    this.lastExp = JSON.parse(localStorage.getItem('LastExperience'));
  }

}
